import { BrandState } from 'types/brand'

export const CONFIRM_BRAND = 'CONFIRM_BRAND'
export const confirmBrandAction = (params: BrandState['confirm']) => {
  return {
    type: 'CONFIRM_BRAND',
    payload: params,
  }
}

export const FETCH_BRANDS = 'FETCH_BRANDS'
export const fetchBrandsAction = (brands: BrandState['brands']) => {
  return {
    type: 'FETCH_BRANDS',
    payload: brands,
  }
}

export const INIT_BRAND = 'INIT_BRAND'
export const initBrandAction = () => {
  return {
    type: 'INIT_BRAND',
    payload: null,
  }
}
